/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForUnitRateCrawler extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForUnitRateCrawler");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForUnitRateCrawler.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForUnitRateCrawler>): BackgroundJobPayloadForUnitRateCrawler {
        let obj = Object.assign(new BackgroundJobPayloadForUnitRateCrawler(), model);
        BackgroundJobPayloadForUnitRateCrawler.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForUnitRateCrawler>): BackgroundJobPayloadForUnitRateCrawler {
        if (!model) return null;
        return BackgroundJobPayloadForUnitRateCrawler.newInstance(<BackgroundJobPayloadForUnitRateCrawler> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForUnitRateCrawler) {
        if (!obj) return;

        models.BackgroundJobPayloadForUnitRateCrawler.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForUnitRateCrawler): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForUnitRateCrawler.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.configuration) {
            models.UnitRateCrawlerConfiguration.fixupPrototype(this.configuration);
        }
    }

    configuration: models.UnitRateCrawlerConfiguration;

}
